import CONTACT_INFO from './tsContactInfo';

/* eslint-disable quotes */
export const SUMMARY_CONTENT = `These terms of use (“Terms of Use”) are a legal agreement between you \
and, if you are a resident of the United States, www.trustscience.com USA Inc. or, if you are a \
resident of Canada, Trust Science Inc. (collectively, “Trust Science,” “we,” “our,” or “us”) \
and govern your access to and use of the Trust Science® Smart Consent™ mobile application \
(the “App” or “Smart Consent™”) and any of the services available on any website maintained \
by Trust Science (“Services Sites”). By accessing or using the App or Services Sites, you agree \
to be legally bound by these Terms of Use.`;

export const CONTENT = [
  {
    title: 'The Smart Consent™ App',
    content: `The Smart Consent™ App enables third parties to look beyond your credit history and make \
decisions based on your unique trust profile. The App collects your personal \
information, which is combined with data from other sources, and Trust Science applies \
complex algorithms and machine learning to create a trustworthiness profile. \
Depending on our agreement with the third party, Trust Science may also provide a Trust \
Report™, Six Score™, or other analysis. These products differ from traditional consumer \
reports, because Trust Science determines your trustworthiness based on data gathered \
from social media, web searches, and your mobile device. The App is also used to provide \
you with information about Trust Science’s products and services, and to facilitate \
communication with us, our partners, and third parties of your choice.`,
  },
  {
    title: 'Consumer Support',
    content: `In accordance with the Fair Credit Reporting Act and Canadian credit reporting \
and privacy laws, Trust Science allows you to request a disclosure of the information we maintain \
about you, dispute information in your Trust File, ask a question, submit a complaint, request \
us to place a security alert in your file or to block information resulting from fraud or \
identity theft, and request information about our policies and practices. In addition to viewing \
or requesting Trust Reports and submitting requests through the App or Service Sites, you can \
contact us by emailing us at ${CONTACT_INFO.emailSupport}, or call us toll-free at ${CONTACT_INFO.phoneNumber}. \
Trust Science provides Trust File disclosures free of charge.
Trust Science will retain any Trust Report, Six Score, or corollary analysis for two years from the \
date on which it was created, unless otherwise required by law Trust Science is not a credit or credit \
repair organization and does not provide credit or credit repair advice. Trust Science differs from \
traditional consumer reporting agencies in that it does not maintain credit information furnished by creditors, \
and it does not combine or cross-reference its trustworthiness files with information furnished by creditors or \
maintained by other consumer reporting agencies. United States residents have additional rights regarding nationwide \
consumer reporting agencies.`,
  },
  {
    title: 'Term and Termination; Modification',
    content: `These Terms of Use will take effect at the time you click “I Accept.” Trust Science \
may change or terminate these Terms of Use, modify or discontinue the App or Services Sites, or \
suspend or terminate your use or access of the App or Services Sites for any reason, without \
notice. You may terminate these Terms of Use by contacting Trust Science via the contact \
information in the preceding section. Any change to these Terms of Use will be effective when \
posted or as otherwise stated, and your continued use of the App or Services Sites will \
constitute your consent to those changes. Additional terms and conditions may apply to specific \
products and services or to participate in our affiliate or partnership program or surveys.`,
  },
  {
    title: 'Intellectual Property',
    content: `The images, text, screens, web pages, materials, data, content, and other information \
(“Content”) used and displayed on the App or Service Sites, including but not limited to Smart Consent™ \
and Six Score™, are the property of Trust Science or its licensors and are protected by copyright, \
trademark, and other laws. In addition to our rights in individual elements of the Content within \
the App and Service Sites, Trust Science owns copyright or patent rights in the selection, \
coordination, arrangement, and enhancement of such Content. You may copy the Content from then Site \
for your personal or educational use only, provided that each copy includes any copyright, trademark\
, or service mark notice or attribution as they appear on the pages copied. Except as provided in \
the preceding sentence, none of the Content may be copied, displayed, distributed, downloaded, \
licensed, modified, published, reposted, reproduced, reused, sold, transmitted, used to create a \
derivative work, or otherwise used for public or commercial purposes without the express written \
permission of Trust Science or the owner of the Content.`,
  },
  {
    title: 'Disclaimers',
    content: `THE APP, SERVICES SITES, CONTENT, PRODUCTS, AND SERVICES ARE PROVIDED ON AN “AS IS” \
BASIS, WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES \
OF ACCURACY, NON-INFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE. NEITHER TRUST \
SCIENCE NOR ITS AFFILIATES WARRANT THAT THE APP, SERVICES SITES, CONTENT, PRODUCTS, OR SERVICES \
WILL BE ERROR-FREE, CONTINUOUS, UNINTERRUPTED, OR SECURE. TRUST SCIENCE DISCLAIMS ALL LIABILITY FOR \
ANY ACTS OR OMISSIONS OF ANY THIRD PARTY IN CONNECTION WITH OR RELATED TO THE APP, \
SERVICES SITES, CONTENT, PRODUCTS, OR SERVICES. YOU AGREE THAT YOUR ACCESS TO AND USE OF OUR APP, \
SERVICES SITES, CONTENT, PRODUCTS, AND SERVICES ARE ENTIRELY AT YOUR OWN RISK.`,
  },
  {
    title: 'Limitation of Liability',
    content: `IN NO EVENT SHALL TRUST SCIENCE OR ITS AFFILIATES BE LIABLE FOR ANY DIRECT, INDIRECT, \
SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH YOUR \
ACCESS TO OR USE OF OUR APP, SERVICES SITES, CONTENT, PRODUCTS, OR SERVICES, EVEN IF WE HAVE BEEN \
ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, INCLUDING LIABILITY ASSOCIATED WITH ANY COMPUTER MALFUNCTION OR DAMAGE.`,
  },
  {
    title: 'Registration and Accurate Information',
    content: `If you use our App or Services Sites, purchase our products or services, or participate \
in our affiliate programs or surveys, you may be required to register, provide personal information, \
and select a user name and password. You agree to provide accurate information in your registration \
and not to share your password with third parties. You agree not to impersonate another person or to \
select or use a user name or password of another person. You agree to notify Trust Science promptly of \
any unauthorized use of your account and of any loss, theft, or disclosure of your password. Failure \
to comply with these requirements shall constitute a breach of these Terms of Use and shall constitute \
grounds for immediate termination of your account and your right to use the App and Services Sites.`,
  },
  {
    title: 'Our Privacy Policy',
    content: `By using the Smart Consent™ App or Services Sites, or by using any of our products or services, \
you agree to allow Trust Science and/or the App to access your mobile device, contacts, location, \
social media accounts, and other data in accordance with our Privacy Policy. You further agree that \
we may use and share your personal information in accordance with the terms of our Privacy Policy.`,
  },
  {
    title: 'Submissions',
    content: `Trust Science reserves the right to publish or use any responses, questions, or comments \
for promotional or other purposes without any further permission, notice, or payment of any kind to \
the sender. All such submissions will be the property of Trust Science.`,
  },
  {
    title: 'Eligibility',
    content: `Only citizens of the United States and Canada may use and access the App and Services Sites. \
You may not access or use the App or Services Sites if you are a resident of Nova Scotia or Prince Edward \
Island. You must be at least 18 years of age to use or access the App or Services Sites.`,
  },
  {
    title: 'Notices',
    content: `You should send any notices or other communications regarding our App, Services Sites, \
products, or services to ${CONTACT_INFO.emailInfo}. Except as otherwise provided, we may send any notices \
to you to the most recent email address you have provided to us or, if you have not provided an email \
address, to any email or postal address that we believe is your address. If you wish to update your \
registration information, please log in to your account and visit the 'Personal Details'; section from the main menu.`,
  },
  {
    title: 'Applicable Law',
    content: `These Terms of Use shall be governed by the laws of the State of Texas, without regard \
to any conflict of law provisions. You agree that any disputes arising under these Terms of Use or \
out of provision of services to you, if submitted to a court of law, shall be submitted to the law \
courts of Houston, Texas or, if you are a resident of Canada, to the courts of Vancouver, British \
Columbia. Trust Science’s failure to exercise any right under these Terms of Use does not constitute \
a waiver of such right. If any provision of these Terms of Use is found by a court of competent \
jurisdiction to be invalid, then it shall be interpreted to accomplish the objectives to the greatest \
extent possible, and the other provisions will remain in full force and effect.`,
  },
];
